<template>
  <div>
    <b-modal v-model="showModal"
      :title="title"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="lg">
      <div class="container">
        <div class="row">
          <div class="col-12" >
            <div v-if="topics" v-for="(topic, index) in topics" :key="index">
              <div class="bg-text mb-2">
                  <div class="m-2">
                      <h5><b><u class="section-title">{{ topic.topic }} &nbsp;</u></b></h5>
                  </div>
                  <div v-if="topic.image">
                      <div class="col-12">
                          <p style="text-align: justify;" v-html="topic.description"></p>
                          <br>
                      </div>
                      <div class="col-12 d-flex align-items-center justify-content-center pb-3">
                          <img class="b-radius shadow" :src="url+'/storage/images/topics/'+topic.image" alt="" width="70%">
                      </div>
                  </div>
                  <div v-else-if="topic.description">
                      <div class="col-12 mb-0">
                          <p style="text-align: justify;" v-html="topic.description"></p>
                          <br>
                      </div>
                  </div>
                  <div v-if="topic.sortedDefinitions && topic.sortedDefinitions.length > 0" class="container-fluid pl-2">
                    <h5><b><u class="section-title">
                        <i class="fas fa-caret-right"></i> Definiciones: &nbsp;</u></b>
                    </h5>
                  </div>
                  <div v-if="topic.sortedDefinitions" v-for="(definition, index) in topic.sortedDefinitions" :key="index" class="mr-1 ml-1">
                      <div v-if="definition.image">
                          <div class="col-12 bg-text-d mt-0 shadow" >
                            <div v-if="definition.position_img===4" class="row">
                              <!-- Imagen al lado del texto en pantallas grandes (md o superior) -->
                              <div class="col-md-4 d-none d-md-flex align-items-center justify-content-center p-1">
                                <img class="b-radius shadow" :src="url+'/storage/images/definitions/'+definition.image" alt="" width="100%">
                              </div>

                              <div class="col-md-8">
                                <br>
                                <label><b><u>{{ definition.definition }}: </u></b></label>
                                <p style="text-align: justify;" v-html="definition.description"></p>
                                <br>
                              </div>

                              <!-- Imagen debajo del texto en pantallas pequeñas (solo esta se debe mostrar en pantallas pequeñas) -->
                              <div class="col-12 d-md-none d-flex align-items-center justify-content-center p-1">
                                <img class="b-radius shadow" :src="url+'/storage/images/definitions/'+definition.image" alt="" width="100%">
                              </div>
                            </div>

                            <div v-if="definition.position_img===3" class="row">
                              <div class="col-md-12">
                                <br>
                                <label><b><u>{{ definition.definition }}: </u></b></label>
                                <p style="text-align: justify;" v-html="definition.description"></p>
                                <br>
                              </div>

                              <!-- Imagen debajo del texto en pantallas pequeñas (solo esta se debe mostrar en pantallas pequeñas) -->
                              <div class="col-12 d-flex align-items-center justify-content-center p-1">
                                <img class="b-radius shadow" :src="url+'/storage/images/definitions/'+definition.image" alt="" width="100%">
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                              <hr>
                          </div>
                      </div>
                      <div v-else class="">
                          <div class="col-12 bg-text-d shadow">
                              <br>
                              <label><b><u>{{ definition.definition }}: </u></b></label>
                              <p style="text-align: justify;" v-html="definition.description"></p>
                              <br>
                          </div>

                          <div class="col-12">
                              <hr>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-sm btn-danger" type="button" @click="close"> <i class="fas fa-times fa-fw"></i>Terminar Lectura</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal } from 'bootstrap-vue';

export default {
  components: {BModal},
  props: ['data', 'showModal'],
  data() {
    return {
      form: {},
      topics: [],
      title: null,
      url: null,
      moduleProgress: [],
      // // Variables para el cronómetro
      hours: 0,
      minutes: 0,
      seconds: 0,
      timeString: '00:00:00', // Variable para mostrar el tiempo en formato HH:MM:SS
      timer: null, // Variable para almacenar el temporizador
      countTime: null, // Variable para almacenar el tiempo guardado
      readTime: null,
      practiceTime: null,
    }
  },
  mounted(){
    this.title = "Lectura de Módulo: "+this.data.module;
    this.topics = this.data.sortedTopics;
    this.url = this.data.url;
    this.moduleProgress = this.data.moduleProgress;
    this.readTime = this.data.read_time;
    this.practiceTime = this.data.practice_time;
    this.playProgress();
  },
  methods:{
    close(bvModalEvent) {
      this.timerCounter('stop');
      this.saveModuleProgress(this.moduleProgress.id, this.countTime, this.data.courseid)
    },
    saveModuleProgress(id, countTime, courseid) {
      let status = null;

      let readPrecent = this.precentTime(this.readTime, countTime);
      let practicePrecent = this.precentTime(this.practiceTime, this.data.moduleProgress.practice_time);

      if(readPrecent>=100 && practicePrecent>=100 && this.data.moduleProgress.status==1 && this.data.moduleProgress.score>=75){
        status = 2;
      }

      axios.post('/saveModuleProgress', { id: id, read_time: countTime, status: status, courseid: courseid })
        .then(response => {
            if (response.data.status == 'error') {
            toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
            };
        })
        .catch(error => {
            console.error(error);
        })
        .finally(() => {
          this.$emit('loadProgress', this.moduleProgress.id );
          this.$emit('update:showModal', false);
        });

    },
    playProgress(){
      this.timerCounter('play', this.moduleProgress.read_time);
    },
    timerCounter(control, startTime) {
      if (control === 'play') {
        this.timer = setInterval(() => {
            this.seconds++;
            if (this.seconds >= 60) {
                this.seconds = 0;
                this.minutes++;
                if (this.minutes >= 60) {
                    this.minutes = 0;
                    this.hours++;
                }
            }
            this.timeString = this.formatTime(this.hours, this.minutes, this.seconds);
            localStorage.setItem('read_time', this.timeString);
            this.countTime = this.timeString
        }, 1000);
      } else if (control === 'pause') {
          clearInterval(this.timer);
          // Guardar el tiempo actual en una variable
          localStorage.setItem('read_time', this.timeString);
      } else if (control === 'stop') {
          clearInterval(this.timer);
          // Restablecer el cronómetro
          this.seconds = 0;
          this.minutes = 0;
          this.hours = 0;
          this.timeString = '00:00:00';
          // Guardar el tiempo actual en una variable
          localStorage.setItem('read_time', this.timeString);
      }

      // Si se proporciona un tiempo de inicio, establecer el cronómetro en ese tiempo
      if (startTime) {
          const [startHours, startMinutes, startSeconds] = startTime.split(':').map(Number);
          this.hours = startHours;
          this.minutes = startMinutes;
          this.seconds = startSeconds;
          this.timeString = startTime;

      }
    },
    formatTime(hours, minutes, seconds) {
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },
    //Convierte el tiempo string a fomarto date para comprar el tiempo base y el tiempo acumulado
    convertSeconds(time) {
            const partsTime = time.split(":");
            return partsTime[0] * 3600 + partsTime[1] * 60 + partsTime[2] * 1;
        },
    //Se calcula el procentaje en base al tiempo requerido y el tiempo acumulado
    precentTime(readTime, read_time_progress){
        let result = 0;
        if(this.convertSeconds(read_time_progress) >= this.convertSeconds(readTime)){
            return result = 100;
        }else{
            // Convertir tiempo requerido y progreso a segundos totales
            const timerequeredSeconds = this.convertSeconds(readTime);
            const progressSeconds = this.convertSeconds(read_time_progress);

            // Calcular el porcentaje
            let percent = Math.round((progressSeconds / timerequeredSeconds) * 100);
            result = percent === 100 ? percent.toString() : percent.toString().padStart(2, '0');
            return result;
        }

    },
  }
}

</script>